import { render } from "./organisation-send-loa.vue?vue&type=template&id=49ffb828&scoped=true"
import script from "./organisation-send-loa.vue?vue&type=script&lang=js"
export * from "./organisation-send-loa.vue?vue&type=script&lang=js"

import "./organisation-send-loa.vue?vue&type=style&index=0&id=49ffb828&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49ffb828"]])

export default __exports__